import get from 'lodash.get';

const getSentryDSN = (rootState) => get(rootState, 'config.auth-gateway.sentry_dsn');

export default getSentryDSN;
